import cn from 'classnames';
import dayjs from 'dayjs';
import Image from 'next/image';
import { FC } from 'react';

import useMembership from '~utils/hooks/useMembership';

import s from './QRWindow.module.css';

interface Props {
  loyaltyNumber: string;
}

export const QrCard: FC<Props> = ({ loyaltyNumber }) => {
  const { data } = useMembership();
  const readyToUse = !data?.memberSince ? true : dayjs().diff(dayjs(data?.memberSince), 'days') > 1;
  return (
    <div className={s.userCardLoyalty}>
      <div className={s.content}>
        <div className={s.loyaltyHeader}>
          <div className={s.citipremiaImageWrapper}>
            <Image
              src="/img/citiid-2.png"
              fill
              className="object-contain"
              sizes="250px"
              alt="Imagen de fondo con motivos Citipremia"
            />
          </div>
          <div role="presentation" className={s.loyaltyNumber}>
            {loyaltyNumber}
          </div>
          <div role="presentation" className={s.loyaltyCopy}>
            {readyToUse
              ? '¡Presenta tu tarjeta CitiPremia o este QR en cualquier punto de venta' +
                ' Citicinemas y disfruta de tus beneficios!'
              : 'Tu cuenta CitiPremia está activa, sin embargo, podrás disfrutar de los' +
                ' beneficios 24 horas después de la activación.'}
          </div>
        </div>
        <div className={cn(s.loyaltyQRWrap, !readyToUse ? 'opacity-40 blur-sm' : null)}>
          <Image
            src={`${process.env.NEXT_PUBLIC_API_BASEURL}/qr/card/${loyaltyNumber?.replace(
              /\s/gm,
              '',
            )}`}
            fill
            className="object-cover"
            quality={100}
            alt="Imagen QR de la tarjeta de lealtad"
            sizes="320px"
            loader={({ src }) => src}
          />
        </div>
      </div>
    </div>
  );
};
const QRWindow: FC<Props> = ({ loyaltyNumber }) => {
  return (
    <div className="max-w-[320px]">
      <QrCard loyaltyNumber={loyaltyNumber} />
    </div>
  );
};

export default QRWindow;
